import t from "./deliveryMethodSelect.ce.vue2.js";
import e from "./deliveryMethodSelect.ce.vue3.js";
import o from "../../../_virtual/_plugin-vue_export-helper.js";
const f = /* @__PURE__ */ o(t, [["styles", [e]], ["__scopeId", "data-v-6a939f42"]]);
export {
  f as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/delivery-method/components/deliveryMethodSelect.ce.vue.js
// module id = 829
// module chunks = 41